// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"378":"BuffetPage","703":"HomePage","860":"createApp"}[chunkId] + "." + {"378":"9ae78365","703":"b551ebca","860":"e3f4935c"}[chunkId] + ".js";
};